export const IMAGE = ['jpg', 'jpeg', 'png', 'webp', 'svg', 'jfif'];

export const VIDEO = ['mp4', 'webm', '3gp'];

export const PDF = ['pdf'];
